import type { PrevisaoEstoqueApiItem } from "./types";

function toNumber(value: unknown): number {
  const num = Number(value);
  return Number.isNaN(num) ? 0 : num;
}

/**
 * Normaliza o retorno de GET /web/previsao-estoque
 * (array conforme contrato do Swagger).
 */
export function normalizePrevisaoEstoqueResponse(payload: unknown): PrevisaoEstoqueApiItem[] {
  if (!Array.isArray(payload)) return [];

  return payload
    .filter((item): item is Record<string, unknown> => !!item && typeof item === "object")
    .flatMap(row => {
      const insumoId = row.insumoId != null ? String(row.insumoId) : "";
      if (!insumoId) return [];

      const item: PrevisaoEstoqueApiItem = {
        insumoId,
        estoqueFazenda: toNumber(row.estoqueFazenda),
        fatorEmbalagem: toNumber(row.fatorEmbalagem),
        programadoEmOs: toNumber(row.programadoEmOs),
      };

      if (row.insumoCodigo != null && String(row.insumoCodigo).trim() !== "") {
        item.insumoCodigo = String(row.insumoCodigo);
      }

      return [item];
    });
}
